import React from "react";

interface InputFieldProps {
  label: string;
  name: string;
  value: any;
  onChange: (e: any) => void;
  onBlur?: (e: any) => void;
  placeholder?: string;
  type?: string;
  readOnly?: boolean;
  required?: boolean;
  error?: string;
  [key: string]: any;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  readOnly,
  required = false,
  error,
  ...props
}) => {
  // const [isTouched, setIsTouched] = useState(true);

  const handleChange = (e: any) => {
    onChange(e);
  };

  const handleBlur = (e: any) => {
    // setIsTouched(true);
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div className="flex flex-col w-full">
      <label className="block text-xl font-normal text-[#889DB2] mb-2">
        {label}
      </label>
      <div className="flex">
        <input
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          className={`flex-1 px-3 py-2 text-xl rounded-lg shadow-lg bg-[#2E4051] border-none focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
            error ? "border-red-500 bg-red-50 text-black" : "text-[#F4F5F7] "
          }`}
          {...props}
          readOnly={readOnly}
          required={required}
        />
      </div>
      {error && (
        <div className="flex mt-1">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}
    </div>
  );
};

export default InputField;
